export const createQuestionButtonDataSet = { cy: 'create-question-button-quiz' };
export const finishQuizButtonDataSet = { cy: 'finish-quiz-button' };
